import { UserSettings } from 'src/types/UserSettings.ts';
import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { sortAccessories } from 'src/modules/common/utils/sortAccessories.ts';
import { SensorsAccessoriesPageData } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { LocationState } from 'src/sensors/LocationState.ts';
import { Accessory, prepareAccessories } from 'src/common/prepareAccessories.ts';
import { subtotalAccessories } from 'src/common/subtotalAccessories.ts';

export const calculateTotals = (
    {
        sensor,
        accessories: sensorAccessories,
    }: SensorsAccessoriesPageData['accessories'],
    userSettings: UserSettings,
    checkoutState: LocationState,
    currency: string | null,
): {
    subtotal: number;
    accessoriesSubtotal: number;
    total: number;
    currentCurrency: string;
    accessories: Accessory<SensorsAccessoriesPageData['accessories']['accessories']['0']>[];
    pricePerUnit: number;
} => {
    const sensorPrice = getPriceValue(sensor, userSettings.shoppingCenter as keyof typeof sensor, currency);
    const currentCurrency = sensorPrice?.currency || currency || 'USD';
    const pricePerUnit = sensorPrice ? sensorPrice.value : 0;
    const subtotal = pricePerUnit * checkoutState.qty;

    const accessories = prepareAccessories<SensorsAccessoriesPageData['accessories']['accessories']['0']>(
        sensorAccessories,
        checkoutState.selectedAccessories,
        userSettings,
        currency,
        (a, b) => sortAccessories(a.accessory, b.accessory),
    );

    const accessoriesSubtotal = subtotalAccessories<
    SensorsAccessoriesPageData['accessories']['accessories']['0']['item']
    >(accessories);

    const total = subtotal + accessoriesSubtotal;

    return {
        subtotal,
        accessoriesSubtotal,
        total,
        currentCurrency,
        accessories,
        pricePerUnit,
    };
};
